import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import api from "@/api";
import { ElMessage, ElNotification } from "element-plus";
import DialogCustomView from "@/components/DialogCustomView.vue";
import constants from "@/utils/constants";
import { VueDraggableNext } from "vue-draggable-next";
export default {
  name: "IceOssUploader",
  components: {
    DialogCustomView,
    draggable: VueDraggableNext
  },
  props: {
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      files: [],
      ossDomain: null,
      ossFolder: null,
      uploaded: [],
      preview: false,
      preivewImg: null
    };
  },
  watch: {
    fileList() {
      this.initFileList();
    }
  },
  methods: {
    draggableChange() {
      this.uploaded = this.files.map(item => item.url);
      this.$emit('onUploaded', this.uploaded);
    },
    getFileIcon(file) {
      if (file.response != null) {
        return constants.getFileIcon(file.response.url);
      }
      return constants.getFileIcon(file.url);
    },
    initFileList() {
      this.files = [];
      this.uploaded = [];
      console.log('dataStatisticSnapshot', this.fileList);
      if (this.fileList) {
        this.files = this.fileList.map(f => {
          this.uploaded.push(f);
          return {
            name: f,
            url: f
          };
        });
      }
    },
    handleRemove(file) {
      // console.log('delete file',file)
      // let url = file.response == null ? file.url : file.response.url;
      // console.log('before filter',this.files)
      // this.files = this.files.filter(itm => itm.url !== url);
      // console.log('after filter',this.files)
      this.$refs.uploader.handleRemove(file);
    },
    isMp4(file) {
      if (file.response != null) {
        return file.response.url.endsWith('mp4');
      }
      return file.url.endsWith('mp4');
    },
    isImage(file) {
      let url = file.response == null ? file.url : file.response.url;
      url = url?.toLowerCase();
      return url.endsWith('jpg') || url.endsWith('jpeg') || url.endsWith('png') || url.endsWith('svg') || url.endsWith('gif') || url.endsWith('bmp');
    },
    initOssClint() {
      let OSS = require('ali-oss');
      api.getOssKeySecret().then(cfg => {
        this.ossClient = new OSS({
          region: cfg.region,
          accessKeyId: cfg.accessKeyId,
          accessKeySecret: cfg.accessKeySecret,
          stsToken: cfg.securityToken,
          bucket: cfg.bucket,
          endpoint: cfg.endpoint,
          secure: true
        });
        this.ossDomain = cfg.domain;
        this.ossFolder = cfg.folder;
      });
    },
    uploadRequest(options) {
      try {
        let file = options.file; // 拿到 file
        let guid = this.guid();
        let notification = ElNotification.warning({
          title: file.name,
          dangerouslyUseHTMLString: true,
          message: `<span id='${guid}'>正在开始上传</span>`,
          duration: 0,
          showClose: false
        });
        const progress = p => {
          // Object的上传进度。
          document.getElementById(guid).textContent = `上传进度:${(p * 100).toFixed(0)}%` || '';
        };
        let fileType = file.name.substr(file.name.lastIndexOf('.'));
        let fileName = (this.ossFolder ? this.ossFolder + '/' : 'user-upload/') + guid + fileType;
        // 上传文件,这里是上传到OSS的 uploads文件夹下
        this.ossClient.multipartUpload(fileName, file, {
          progress
        }).then(res => {
          if (res.res.statusCode === 200) {
            res.url = this.ossDomain + '/' + res.name;
            options.onSuccess(res);
            notification.close();
          } else {
            options.onError("上传失败");
            notification.close();
          }
        }).finally(() => {});
      } catch (e) {
        console.log('上传出错了', e);
        options.onError("上传出错", e);
      }
    },
    beforeImageUpload(file) {
      const suffixLimit = ['png', 'jpg', 'jpeg', 'mp4', 'gif'];
      let check = false;
      for (let sf of suffixLimit) {
        if (file.name.toLowerCase().endsWith(sf)) {
          check = true;
        }
      }
      if (!check) {
        ElMessage.error('仅支持' + suffixLimit.join('、') + '格式');
      }
      return check;
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    handleImageUploadSuccess(url, file) {
      this.files.push(file);
      this.uploaded.push(url);
      this.$emit('onUploaded', this.uploaded);
    },
    handleUploadImageRemove(d) {
      let url = d.response == null ? d.url : d.response.url;
      let idx = this.uploaded.indexOf(url);
      if (idx >= 0) {
        this.uploaded.splice(idx, 1);
        this.$emit('onUploaded', this.uploaded);
        console.log('删图了!');
      }
    },
    onPreview(p) {
      if (this.isImage(p)) {
        this.preivewImg = p.response.url;
        this.preview = true;
      } else {
        ElMessage.info('仅支持预览图片');
      }
    },
    init() {
      this.initOssClint();
    }
  },
  mounted() {
    this.initFileList();
    this.init();
  }
};